import { render, staticRenderFns } from "./EndChapCard.vue?vue&type=template&id=5bc86bef&scoped=true&"
import script from "./EndChapCard.vue?vue&type=script&lang=js&"
export * from "./EndChapCard.vue?vue&type=script&lang=js&"
import style0 from "./EndChapCard.vue?vue&type=style&index=0&id=5bc86bef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc86bef",
  null
  
)

export default component.exports